import { render, staticRenderFns } from "./IconVerticalDots.vue?vue&type=template&id=02daf608&"
import script from "./IconVerticalDots.vue?vue&type=script&lang=js&"
export * from "./IconVerticalDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports